<template>
    <v-col :class="['pa-0 pt-4 pl-0', styleClass]">
        <v-card class="flex pa-0 background-2 round-card fill-height" v-if="!$store.getters.progress">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">{{ title }}</p>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon class="ml-2" small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>{{ tooltip }}</span>
                </v-tooltip>
                <v-spacer></v-spacer>
			    <v-row class="pa-0 ma-0 pr-4">
                    <v-text-field class="hidden-xs-only font-weight-regular"
                        append-icon="mdi-magnify"
                        label="Cerca"
                        v-model="search"
                        clearable
                        hide-details
                        background-color="background-2"
                        outlined
                        dense
                    ></v-text-field>
			    </v-row>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2" v-on="on" @click.native.stop="downloadCsv()" icon>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </template>
                    <span>Download</span>
                </v-tooltip>
            </v-card-title>
            <v-divider></v-divider>

            <v-container class="py-0" fluid>
                <v-row class="ma-0">
				    <v-col cols="12" class="hidden-sm-and-up pa-3">
                        <v-text-field
                            append-icon="mdi-magnify"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>

            <v-data-table
				:options.sync="pagination"
			    :server-items-length="totalItems"
                :search="search"
                class="background-2"
                :headers="headers"
                :items="items"
                :mobile-breakpoint="0">
                <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                    <tr class="cursor-pointer">
                        <template v-for="(header, h) in headers">
                            <td v-if="header.type === 'datetime'" :key="h">
                                <div>
                                    {{ item[header.value] | datetime }}
                                </div>
                            </td>
                            <td v-else :key="h">
                                {{ item[header.value] }}
                            </td>
                        </template>
                    </tr>
                </template>
                <template v-slot:footer.page-text="{ pageStart, pageStop }">
                    Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
                </template>
            </v-data-table>
        </v-card>
    </v-col>
</template>

<script>

export default {
    name: 'whatsapp-campaign-analytics-recipients',
    props: {
        id: Number,
        url: String,
        title: String,
        headers: Array,
        tooltip: String,
        styleClass: {
            type: String,
            default: 'col-12 col-lg-6',
        },
    },

    data() {
        return {
            loading: false,
            search: '',
            items: [],
            totalItems: 0,
            pagination:  {
                'sortBy': ['id'],
                'sortDesc': [false],
                'page': 1,
                'itemsPerPage': 10,
                'totalItems': 0,
            },
        }
    },

	watch: {
        pagination: {
            handler() {
                this.getData()
            },
            deep: true,
        },

        search: {
            handler() {
                if(this.pagination.page !== 1) {
                    this.$set(this.pagination, 'page', 1)
                }
                this.getData()
            }
        },
    },

    methods: {

        getData() {

            if(this.apiTimeout) {
                clearTimeout(this.apiTimeout)
            }

            this.apiTimeout = setTimeout(() => {
                this.loading = true

                let dataObject = {
                    page: this.pagination.page,
                    per_page: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy,
                    sortDesc: this.pagination.sortDesc,
                    filter: this.search,
                }

                this.axios.post(this.url + '/' + this.id, dataObject).then(response => {
                    this.loading = false
                    this.items = response.data.data.data
                    this.totalItems = response.data.data.total

                }, response => {
                    // error callback
                    this.loading = false
                })
            }, 500)
        },

        downloadCsv() {
            this.$eventBusUtility.openFile(this.$store, this.url + '-csv/' + this.id, this.title + '.csv', 'POST')
        }
    }
}
</script>

<style>

</style>
